import { gql } from 'apollo-boost';

import { MESSAGE_FRAGMENT } from '../fragments/message-fragment';

export const ADMIN_CREATE_MESSAGE = gql`
  ${MESSAGE_FRAGMENT}
  mutation AdminMessageCreate($input: AdminMessageCreateInput!){
    admin_message_create(input: $input){
        message {
            ...messageFragment
        }
    }
  }
`;
